import React, { useState, useEffect } from 'react';
import { useParams, ScrollRestoration } from 'react-router-dom';
// Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from '../config';
import API from '../API'
// Components
import Header from './Header';
import Thumb from './Thumb';
import Knoppie from './Knoppie';
import InfoButton from './InfoButton'
import ClubHeader from './ClubHeader';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid'
import List from './List'

// Hook
import useAuth from '../hooks/useAuth';
import { useTransactionsListFetch } from '../hooks/useTransactionsListFetch';
// Image


let renderCount = 0

const TransactionsList = () => {
  const auth = useAuth();
  const { playerid } = useParams()
  console.log(playerid)
  const [includeSwitch, setIncludeSwitch] = useState(false)


  const { state, loading, error, setSearchValue, setIncludeInactive, setLoading, setTrigger } = useTransactionsListFetch();

  const handleScroll = () => {
    const element = document.getElementById(playerid ? playerid : "")
    console.log("handlescroll is getrigger")
    console.log(element)
    if (element) {
      element.scrollIntoView({

      })

    }

  }


  const handleClick = async (e) => {

    try {

      // eslint-disable-next-line no-restricted-globals
      const confirmation = confirm("Are you sure you want to Delete this transaction? This action cannot be overturned!")
      if (confirmation) {
        setTrigger(true)

        console.log("Sukses, die transaksie gaan delete word hier")
        await API.deleteTransaction(e.target.id, auth.auth.accessToken)

      } else {
        return
      }
    } catch (error) {
      console.log(error)
    }

    console.log("gekliek op" + e.target.id)
    console.log(auth.auth.user.username)

  }

  useEffect(() => {

    if (!loading) {
      handleScroll()
    }

  }, [state])

  const username = auth.auth.user.username

  const access = auth.auth.user.userRole
  // console.log(besluit.besluit[0].besluit)
  console.log(state)

  renderCount++
  return (
    <>

      <Header username={username} role={access} destination={'./'}></Header>

      {access === "administrator" ?
        <Knoppie
          destination={`/Transaction/""/""`}
          text={'New Transaction'}
          from={"/TransactionList"}
          clickable={true}
        />
        : <Knoppie
          destination={`/addNewEmployee`}
          text={'Nie administrator'}
          clickable={true}
        />}

      {/* <h1>RenderCount {renderCount/2}</h1> */}
      <SearchBar key={1} setSearchValue={setSearchValue}></SearchBar>
      <List header={`Transactions ${state.transactions.length}`}
        destination={''}>
        <ButtonGrid>
          <Knoppie
            text={'Show All'}
            clickable={true}
            dropdown={true}
            switchOn={includeSwitch === true}
            callback={() => {
              setIncludeInactive(true)
              setIncludeSwitch(true)
            }}
          />
          <Knoppie
            text={'Show Active Only'}
            clickable={true}
            dropdown={true}
            switchOn={includeSwitch === false}
            callback={() => {
              setIncludeInactive(false)
              setIncludeSwitch(false)
            }}
          />
        </ButtonGrid>
        {error ? "error" : ""}
        <div className='transaction'>
          <div>Type</div>
          <div>Qty</div>
          <div>Date</div>
          <div>Stockitem</div>
          <div>Receive Warehouse</div>
          <div>Despatch Warehouse</div>
          <div>Receive User</div>
          <div>Action</div>
          </div>


        {loading ? <h1>...Loading</h1> : ""}

        {state.transactions.map(item => (

          <>
            <div className='transaction'>


         
              <div>{item.transactionType}</div>
              <div>{item.quantity}</div>
              <div>{item.timestamp ? item.timestamp : "no date"}</div>
              <div>{item.stockitem?.desc|| ""}</div>
              <div>{item.receiveWarehouse?.name || ""}</div>
              <div>{item.despatchWarehouse?.name || "n/a"}</div>
              <div>{item.receiveUser?.username}</div>
              
            



              {<Knoppie
                clickable={true}
                text={"Delete"}

                employeeid={item._id}
                callback={handleClick}
              >

              </Knoppie>}





            </div>

          </>

        ))}


      </List>

    </>
  );
};

export default TransactionsList;

